"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Popover = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactPopper = require("react-popper");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Portal = require("../Portal/Portal");

var _ClickOutside = require("../ClickOutside/ClickOutside");

var _setRef = require("../utils/setRef");

var _useForwardRef = require("../utils/useForwardRef");

var _animation = require("../animation");

var _useDelayBooleanState = require("../utils/useDelayBooleanState");

var _baseStyle = require("../shared/baseStyle");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var PopoverWrapper = _styledComponents.default.div.withConfig({
  displayName: "Popover__PopoverWrapper",
  componentId: "nrq7kn-0"
})(["", " z-index:1100;"], _baseStyle.baseStyle);

var Popover = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      content = _ref.content,
      placement = _ref.placement,
      open = _ref.open,
      _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 0 : _ref$delay,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? 0 : _ref$offset,
      _ref$onMouseEnter = _ref.onMouseEnter,
      onMouseEnter = _ref$onMouseEnter === void 0 ? function () {} : _ref$onMouseEnter,
      _ref$onMouseLeave = _ref.onMouseLeave,
      onMouseLeave = _ref$onMouseLeave === void 0 ? function () {} : _ref$onMouseLeave,
      _ref$onClickOutside = _ref.onClickOutside,
      onClickOutside = _ref$onClickOutside === void 0 ? function () {} : _ref$onClickOutside,
      _ref$arrow = _ref.arrow,
      arrow = _ref$arrow === void 0 ? /*#__PURE__*/_react.default.createElement("div", null) : _ref$arrow,
      _ref$animation = _ref.animation,
      Animation = _ref$animation === void 0 ? _animation.NoAnimation : _ref$animation,
      _ref$animationProps = _ref.animationProps,
      animationProps = _ref$animationProps === void 0 ? {
    duration: 0
  } : _ref$animationProps;

  var _useDelayedBooleanSta = (0, _useDelayBooleanState.useDelayedBooleanState)(open, delay, animationProps.duration),
      _useDelayedBooleanSta2 = _slicedToArray(_useDelayedBooleanSta, 2),
      innerOpen = _useDelayedBooleanSta2[0],
      setInnerOpen = _useDelayedBooleanSta2[1];

  var _useReRenderForwardRe = (0, _useForwardRef.useReRenderForwardRef)(children.ref),
      _useReRenderForwardRe2 = _slicedToArray(_useReRenderForwardRe, 2),
      referenceElement = _useReRenderForwardRe2[0],
      setReferenceElement = _useReRenderForwardRe2[1];

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      popperElement = _useState2[0],
      setPopperElement = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      arrowElement = _useState4[0],
      setArrowElement = _useState4[1];

  (0, _react.useEffect)(function () {
    setInnerOpen(open);
  }, [open, setInnerOpen]);
  (0, _react.useEffect)(function () {
    if (referenceElement) {
      referenceElement.addEventListener('mouseenter', onMouseEnter);
      referenceElement.addEventListener('mouseleave', onMouseLeave);
      return function () {
        referenceElement.removeEventListener('mouseenter', onMouseEnter);
        referenceElement.removeEventListener('mouseleave', onMouseLeave);
      };
    }

    return function () {};
  }, [referenceElement, onMouseEnter, onMouseLeave]);
  (0, _react.useEffect)(function () {
    (0, _setRef.setRef)(ref, popperElement);
  }, [ref, popperElement]);

  var handleClickOutside = _react.default.useMemo(function () {
    return open ? onClickOutside : function () {};
  }, [open, onClickOutside]);

  var _usePopper = (0, _reactPopper.usePopper)(referenceElement, popperElement, {
    modifiers: [{
      name: 'offset',
      options: {
        offset: [0, 10 + offset]
      }
    }, {
      name: 'arrow',
      options: {
        element: arrowElement,
        padding: 10
      }
    }],
    placement: placement,
    strategy: 'fixed'
  }),
      styles = _usePopper.styles,
      attributes = _usePopper.attributes;

  var clonedElement = _react.default.useMemo(function () {
    return /*#__PURE__*/_react.default.cloneElement(children, {
      ref: setReferenceElement
    });
  }, [children, setReferenceElement]);

  var clonedArrow = _react.default.useMemo(function () {
    return /*#__PURE__*/_react.default.cloneElement(arrow, {
      ref: setArrowElement,
      style: styles.arrow
    });
  }, [arrow, styles.arrow]);

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, clonedElement, /*#__PURE__*/_react.default.createElement(_Portal.Portal, {
    name: "popover"
  }, innerOpen && /*#__PURE__*/_react.default.createElement(PopoverWrapper, _extends({
    ref: setPopperElement,
    style: styles.popper
  }, attributes.popper), /*#__PURE__*/_react.default.createElement(_ClickOutside.ClickOutside, {
    onClickOutside: handleClickOutside
  }, /*#__PURE__*/_react.default.createElement(Animation, _extends({}, animationProps, {
    visible: open
  }), /*#__PURE__*/_react.default.createElement("div", null, content), clonedArrow)))));
});
exports.Popover = Popover;